import { useId, type ReactElement, type ReactNode } from 'react';
import { settingsCardStyle, settingsDescriptionStyle, settingsHeadingStyle } from './settingsStyles';

interface SettingsCardProps {
  readonly title: string;
  readonly description?: ReactNode;
  readonly children: ReactNode;
  readonly actions?: ReactNode;
  readonly testId?: string;
  readonly ariaLabel?: string;
}

export function SettingsCard({ title, description, children, actions, testId, ariaLabel }: SettingsCardProps): ReactElement {
  const headingId = useId();
  return (
    <section
      style={settingsCardStyle}
      data-testid={testId}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabel ? undefined : headingId}
    >
      <header style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start', gap: 12, marginBottom: 16 }}>
        <div style={{ flex: '1 1 240px', minWidth: 0 }}>
          <h3 id={headingId} style={settingsHeadingStyle}>{title}</h3>
          {description && <div style={settingsDescriptionStyle}>{description}</div>}
        </div>
        {actions}
      </header>
      {children}
    </section>
  );
}
